<template>
  <Modal v-model="isShowTip"
         class-name="vertical-center-modal">
    <p slot="header"
       :style="headerClassObj">
      <span>{{orderInfo.title}}</span>
    </p>
    <template v-if="type == 3">
      <div class="wrapper">
        <div class="form-group no-result-tip">
          查无该笔交易记录，请联系客服
        </div>
      </div>
    </template>
    <template v-else-if="type == 4">
      <div class="wrapper">
        <div class="form-group no-result-tip">
          {{orderInfo.errorDesc}}
        </div>
      </div>
    </template>
    <template v-else>
      <div class="wrapper">
        <div class="form-group">
          <div class="label-wrap">支付宝交易号</div>
          <div class="form-item-wrap">{{orderInfo.tradeNo}}</div>
        </div>
        <div class="form-group">
          <div class="label-wrap">充值时间</div>
          <div class="form-item-wrap">{{orderInfo.createTime}}</div>
        </div>
        <div class="form-group">
          <div class="label-wrap">交易金额</div>
          <div class="form-item-wrap money-color">{{orderInfo.amount}}</div>
        </div>
      </div>
    </template>

    <div slot="footer">
      <div class="footer-wrapper">
        <span class="btn cancel-btn"
              @click="handelCancel">取消</span>
        <span class="btn confirm-btn"
              @click="handelSubmit">确定</span>
      </div>
    </div>
  </Modal>
</template>
<script>
import { Modal } from 'view-design'
export default {
  name: 'AccountTip',
  components: {
    Modal
  },
  data: function () {
    return {
      type: 1, // 1-充值成功 2-重复充值 3-未查询交易记录
      orderInfo: {
        title: '',
        tradeNo: '',
        createTime: '',
        amount: 0,
        errorDesc: ''
      },
      isShowTip: false
    }
  },
  computed: {
    headerClassObj: function () {
      return {
        color: (this.type == 2) ? '#FF4F76' : '#222222'
      }
    }
  },
  methods: {
    init: function (type, orderInfo) {
      this.type = type
      this.orderInfo = orderInfo
      this.isShowTip = true
    },
    handelCancel: function () {
      this.isShowTip = false
    },
    handelSubmit: function () {
      this.isShowTip = false
    }
  }
}
</script>
<style scoped>
>>> .vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}
>>> .vertical-center-modal .ivu-modal {
  top: 0;
}
>>> .vertical-center-modal .form-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  min-width: 0;
  padding: 0 1.8rem;
  margin-bottom: 0.4rem;
}
>>> .vertical-center-modal .form-group.no-result-tip {
  font-size: 14px;
  color: #222222;
  justify-content: center;
  margin-top: 0.4rem;
}
.vertical-center-modal .form-group .label-wrap {
  font-size: 14px;
  color: #666;
  letter-spacing: 0;
  width: 1.68rem;
  text-align: right;
  margin-right: 0.32rem;
}
.vertical-center-modal .form-group .form-item-wrap {
  flex: 1;
  min-width: 0;
  border-radius: 2px;
  font-size: 14px;
  color: #222222;
  text-align: left;
}
.vertical-center-modal .form-group .form-item-wrap.money-color {
  color: #ff4f76;
}
>>> .vertical-center-modal .ivu-modal-footer {
  border-top: none;
  padding: 12px 18px 12px 18px;
  text-align: right;
}

.footer-wrapper {
  display: flex;
  min-width: 0;
  width: 100%;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.footer-wrapper .btn {
  display: inline-block;
  border-radius: 2px;
  margin-right: 10px;
  padding: 0.1rem 0.68rem;
  font-size: 16px;
  cursor: pointer;
}
.footer-wrapper .btn.confirm-btn {
  background: #ff8622;
  color: #fff;
}
.footer-wrapper .btn.cancel-btn {
  border: 1px solid #eeeeee;
  border-radius: 2px;
  color: #222222;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/promotion/account/modal/Tip.vue